import { blue, orange } from '@mui/material/colors';
import type { PaletteOptions, Theme, ThemeOptions } from '@mui/material/styles';
import { responsiveFontSizes, createTheme } from '@mui/material/styles';
import type { TypographyOptions } from '@mui/material/styles/createTypography';

const defaultPaletteOptions: PaletteOptions = {
  primary: {
    main: blue[700],
    contrastText: '#FFF',
  },
  secondary: {
    main: orange[600],
    contrastText: '#FFF',
  },
};

const defaultTypografyOptions: TypographyOptions = {
  button: {
    fontWeight: 600,
  },
};

export const createApplicationTheme = (options?: ThemeOptions): Theme => {
  const theme = createTheme({
    palette: defaultPaletteOptions,
    typography: defaultTypografyOptions,
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          '#root': {
            height: '100vh',
          },
        },
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1280,
        xl: 1536,
      },
    },
    ...options,
  });

  return responsiveFontSizes(theme);
};
